import { Link } from 'react-router-dom';
import SmartImage from './SmartImage';
import { useLanguage } from '../context/LanguageContext';
import { getLocalizedGuide } from '../data/guides';

export default function GuideCard({ guide }) {
  const { language, localizePath, t } = useLanguage();
  const localizedGuide = getLocalizedGuide(guide, language);

  if (!localizedGuide) {
    return null;
  }

  return (
    <Link to={localizePath(`/guides/${guide.slug}`)} className="guide-card">
      <SmartImage
        src={localizedGuide.cardImage || localizedGuide.image}
        alt={localizedGuide.imageAlt || localizedGuide.title}
        className="guide-card-image"
      />
      <div className="guide-card-body">
        <div className="guide-card-meta">
          <span>{localizedGuide.category}</span>
          <span>{localizedGuide.readTime}</span>
        </div>
        <h3>{localizedGuide.title}</h3>
        <p>{localizedGuide.excerpt}</p>
        <span className="guide-card-link">{t('guides.readGuide')}</span>
      </div>
    </Link>
  );
}
